import React, { useEffect, useRef, useState } from 'react';
import { ScrollRestoration, useLocation} from 'react-router-dom';
import ProductList from './ProductList';
import Sidebar from './Sidebar';
import { useNavigate } from "react-router-dom";
import ProductNotFound from './ProductsNotFound';
import Spinner from './Spinner';
import LoadingOverlay from './LoadingOverlay';
import TopProgressBar from './TopProgressBar';




export interface FilterState {
    filterData: FilterDataStructure[];
    isLoaded: boolean;
    error: any; // You can specify the error type, such as string or an error object type
  }
  
  export interface filter{
    "id": number;
    "name": string;
    "icon": string;
  }
  export interface FilterDataStructure{
    "section_key": string;
    "section_name": string;
    "filters":filter[];
  }

  export interface ActiveFiltersStructure{
    filters: {
      [key: string]: number[];
    };
    sort: string;
    search_query: string;
    page: number;

  }

  
  

  
  interface ProductsData{
    items: _ProductDetail[];
    nextPageCount: number,
    isLoaded: boolean,
    error: null | any
  }

  
  // Update the _ProductDetail interface
  export interface _ProductDetail {
      id: number;
      name: string;
      slug: string;
      description: string;
      old_price: number | null;
      price: number;
      action_price?: number | null;
      action_price_from?: string | null;
      action_price_to?: string | null;
      effective_price?: number;
      striked_price?: number | null;
      has_action?: boolean;
      vat: number;
      size_table: string;
      stock_amount: number;
      difficulty: number;
      parameters: {
        difficulty: number[],
        for_whom: {
          id: number;
          name: string;
          type: string;
          image: string | null;
        }[];
        manufacturer: {
          id: number;
          name: string;
          type: string;
          image: string | null;
        }[];
        category: {
          id: number;
          image: string | null;
          name: string;
          type: string;
        }[];
        size: {
          id: number;
          name: string;
          type: string;
          image: string | null;
        }[];
      
      };
      thumbnail: string;
      images: {
        id: number;
        file: string;
        type: string;
      }[];
      related: {
        id: number;
        title: string;
        difficulty: number;
        old_price: number | null;
        price: number;
        vat: number;
        slug: string;
        thumbnail: string;
      }[];
      variants: ProductVariant[];
    
  }
  export interface ProductVariant {
    id: number;
        type: string;
        language: string;
        size: string | null;
        files: string | null;
        price: number;
        vat: number;
        stock_amount: number;
     
  }
  
  

const Products = () => {
  const initialState: FilterState = {
    filterData: [
     {
       section_key: " ", // Provide a default value for section_key
       section_name: " ", // Provide a default value for section_name
       filters: [
        {"id": 0,
       "name": " ",
       "icon": " "}] // Provide an empty array or default filters
     }],
   isLoaded: false,
   error: null,
 };


 const initialProductState: _ProductDetail = {
  id: 0,
  name: "",
  slug: "",
  description: "",
  old_price: null,
  price: 0,
  vat: 0,
  size_table: "",
  stock_amount: 0,
  difficulty: 0,
  parameters: {
    difficulty:[1,2,3],
    for_whom: [
      {
        id: 0,
        name: "",
        type: "",
        image: null,
      },
    ],
    manufacturer: [
      {
        id: 0,
        name: "",
        type: "",
        image: null,
      },
    ],
    category: [
      {
        id: 0,
        type: "",
        image: null,
        name: ""
      },
    ],
    size:[{
      id:0,
      name:"",
      type:"",
      image:null
    }]
  },
  thumbnail: "",
  images: [
    {
      id: 0,
      file: "",
      type: "",
    },
  ],
  related: [
    {
      id: 0,
      title: "",
      difficulty: 0,
      old_price: null,
      price: 0,
      vat: 0,
      slug: "",
      thumbnail: "",
    },
  ],
  variants: [
    {
      id: 0,
      type: "",
      language: "",
      size: null,
      files: null,
      price: 0,
      vat: 0,
      stock_amount: 0,
    },
  ],
};

const initialActiveFiltersState: ActiveFiltersStructure = {
  
    filters: {},
    sort: "price",
    search_query: "",
    page: 1,
  
}
  //condition pro parsovani url (parsuje url na initu a to nechceme.)
  const initialRender = useRef(true);
  const location = useLocation();
  const navigate = useNavigate();

  const [updateUrl,setUpdateUrl] = useState({state:false,replaceUrl:false});
  const [visitedPages, setVisitedPages] = useState<string[]>([]); // Specify the type as string array
  const [activeFilters, setActiveFilters] = useState<ActiveFiltersStructure>(initialActiveFiltersState);
 const [filtersState, setFiltersState] = useState<FilterState>(initialState);

// Produktové data ve výpisu produktů -----------------
const [productsData, setProductsData] = useState<ProductsData>({items: [],nextPageCount: 0,isLoaded: false,error: null});
//product data, load when filters change.
//const [productDetailData,setProductDetailData] = useState<_ProductDetail>(initialProductState);
const [productItem, setproductItem] = useState({productID: 0,active: ""});
//const [numPage, setNumPage] = useState(1);
const [sortingActive, setSortingActive] = useState(0);
//const [sortHref, setSortHref] = useState("price");
//const [reloadProducts,setReloadProducts] = useState(false);
const [selectedFiltersCheckbox, setSelectedFiltersCheckbox] = useState<number[]>([
]);

const params = new URLSearchParams(window.location.search);

const [fetchFilteredData,setFetchFilteredData] = useState<boolean>(false);




//FETCH FILTERED DATA
useEffect(()=>{
  if (!filtersState.isLoaded){
    return;
  }
  setProductsData(spd=>({...spd,isLoaded:false}));
  const fetchData =async()=> {
    const response = await fetch("/api/products", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(activeFilters)
    });
    const dataProducts = await response.json();
    //console.log("post req_____________________");
     console.log("active post request filters:",JSON.stringify(activeFilters));
    
     setProductsData({
      items: dataProducts.data.data,
      nextPageCount: dataProducts.data.next_page_count,
      isLoaded: true,
      error:null});

      

    return dataProducts;
   }
  
  fetchData();
  
  },[fetchFilteredData])
  
  
   useEffect(()=>{
    if(productsData.isLoaded){
    const scrollPositions = JSON.parse(sessionStorage.getItem('scrollPositions') || '{}');
    if ("main" in scrollPositions) {
      // jednorázové obnovení pozice (návrat z detailu) — klíč pak smazat,
      // aby další změna filtru odscrollovala nahoru na výsledky
      window.scrollTo(0, scrollPositions["main"]);
      delete scrollPositions["main"];
      sessionStorage.setItem('scrollPositions', JSON.stringify(scrollPositions));
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
   },[productsData])


  
 //1. step, always fetch filters
 useEffect(()=>{

  console.log("Fetching filter data....");
  const fetchFiltersData = () => {
    fetch('/api/filters')
        .then((res) => res.json())
        .then((filtersData) => {
            // console.log(filtersData.data);
            initialRender.current = false;
            console.log("Filter data loaded");
           
            //filter check if non null filters
            filtersData.data.forEach((element: FilterDataStructure ) => {
              if(element.filters==null){
                throw new Error('null in filter')
              }
            });


              setFiltersState({
                filterData: filtersData.data,
                isLoaded: true,
                error: null,
              });
           

            

            //setSortingActive(0);
        })
        .catch((error) => {
            setFiltersState({ error,filterData:[], isLoaded: false })
            console.log(error.message);
        });
}

fetchFiltersData();

 },[]);

useEffect(()=>{
  //load data from url on first loading (if there is product url it will load from url etc.)
if(filtersState.isLoaded){
  loadDataFromUrl();
}
},[filtersState.isLoaded])

  // Update the visitedPages state whenever the route changes
  useEffect(() => {
   
    if(location.key!=="default"){
    console.log("non default location",location);

    
   
    
    //console.log(window.location);
      //non default key aka non navigated (first render page)
    }else{

      console.log("Default locatioon",location);
      const scrollPositions = JSON.parse(sessionStorage.getItem('scrollPositions') || '{}');  
      scrollPositions["main"] = 0;
      sessionStorage.setItem('scrollPositions', JSON.stringify(scrollPositions));
    }
    //navigate(location.pathname+location.search);
    //setParseUrl(prev=>!prev);
    //setParseUrl(!parseUrl);
   
    

    if (filtersState.isLoaded) {
      console.log("load");
     loadDataFromUrl();
      //setActiveFilters(_activeFilters);
     }

  }, [location.key]);
//filterstate -> after loading filters parse url.


const loadDataFromUrl = () => {
    setVisitedPages((prevVisitedPages) => [...prevVisitedPages, location.pathname+location.search]);
    console.log("FILTERS ARE LOADED, TIME TO PARSE URL");
    //console.log(window.location);
    const params = new URLSearchParams(window.location.search);
    if(params.size===0){
     //set default sorting by whatever what is on index 0;
     setproductItem((prev)=>({productID: 0, active: ""}));
     setSortingActive(0);
     initialRender.current = false;
     setActiveFilters((prevActiveFilters=>(initialActiveFiltersState)))
     //setActiveFilters(activeFilters);
     setSelectedFiltersCheckbox((prevSelectedFiltersCheckbox) => []);
     setFetchFilteredData((x)=>!x);

     return;
     
    
     //return;
    }
   
    console.log(params.getAll(""));
    const sortParam = params.get('sort'); // 'sort' is the name of the query parameter
    const filterParm = params.get('filter'); //get filter params
    const productParam = params.get("product");
    console.log('Sort parameter:', sortParam);
    console.log('filter parameter:', filterParm);
    console.log("product, param. ",productParam);
    if(productParam!==null){
     //we load product and end
   
     return;
    }else{
     //set default product (it will turn off modal if back from browser :)
   
     setproductItem((prev)=>({productID: 0,active: ""}));
    }
   
    //set filters based on params.
   
    //first load keys from existing filters
    //then use those keys to get parameters
    //then propagate down
    const _filterState = filtersState;
    const _activeFilters = activeFilters;
    //_filterState.filterData

   //filter main params load (page atd.)
   const keys = Object.keys(activeFilters); // Returns ['filters', 'sort', 'search_query', 'page'] (interface) of activefilters.
   //console.log(keys);
   
   keys.forEach((key)=>{
     if(params.get(key)!==undefined && params.get(key)!==null){
       let _size = params.get(key)?.length || 0;
       if( _size >0){
         //const numbersArray: number[]  = params.get(key)?.split(',').map(Number) || [];
   
         switch(key){
           case "sort":
             _activeFilters.sort = params.get(key) || "";
             /*this shouldnt be there -> this should change should be something dynamic from api.*/
             const sortingOptions = {
               items: [
                 // {
                 // 	text: "Nejoblíbenější",
                 // 	href: "favorites"
                 // },
                 {
                   text: "Nejlevnější",
                   href: "price"
                 },
                 {
                   text: "Nejnovější",
                   href: "created"
                 }
               ]
             };
            for(let i=0;i<sortingOptions.items.length;i++){
   
             if(sortingOptions.items[i].href === _activeFilters.sort){
               setSortingActive(i);
               break;
             }
   
            }
             break;
           case "search_query":
             _activeFilters.search_query = params.get(key) || "";
           break;
           case "page":
             _activeFilters.page = params.get(key)?.split(',').map(Number)[0] || 1;
             break;
             default:
               break;
          
       
         }
       }
     }
   })
   //filter params load
   let numbersArray: number[] = [];
    _filterState.filterData.forEach((fd)=>{
      //get state by keys
      if(params.get(fd.section_key)!==undefined && params.get(fd.section_key)!==null){
        //_activeFilters.filters[fd.section_key] = params.get(fd.section_key);
        let _size = params.get(fd.section_key)?.length || 0;
        if( _size >0){
          const existingNumbersArray = params.get(fd.section_key)?.split(',').map(Number) || [];
          numbersArray = Array.from(new Set([...numbersArray, ...existingNumbersArray]));
        console.log("numbersArray",numbersArray);
        _activeFilters.filters[fd.section_key] = existingNumbersArray;
      

       
        }
      }else{
        /*
       //in url key doesnt exist, remove from active filters
       fd.filters.forEach(f => {
        if(selectedFiltersCheckbox.find((number) => number === f.id) !== undefined){
          const updatedArray = selectedFiltersCheckbox.filter((number) => number !== f.id);
    // Update the state with the new array
  
    setSelectedFiltersCheckbox(updatedArray);
    
        }
       });
       delete _activeFilters.filters[fd.section_key];
       //remove checkboxes if they shouldnt exist
       */
  
      }
    })
    setSelectedFiltersCheckbox((prevSelectedFiltersCheckbox) => [
      
     ...numbersArray // Merge the existing and new values
   ]);
    setActiveFilters((prevActiveFilters) => ({
     ...prevActiveFilters,
     filters: _activeFilters.filters,
     page:_activeFilters.page,
     search_query:_activeFilters.search_query,
     sort: _activeFilters.sort
   }));
    //fetch filtered data fix, aby se nefetchovali 2x., 
   setFetchFilteredData((x)=>!x);
}

      //PARSE RECEIVED FILTERS INTO URL
      useEffect(()=>{

        if (initialRender.current) {
          initialRender.current=false;
          console.log("no regen");
          return;
        }
        console.log("UPDATE URL RECIEVED");
          //console.log("url update requested");
        const generateHref = (_filters: ActiveFiltersStructure): string => {
         const { filters, sort, search_query, page } = _filters;
      
         // Create the query string based on the properties
         let queryString = `sort=${sort}&search_query=${search_query}&page=${page}`;
       
         // Add filter parameters to the query string
         for (const filterKey in filters) {
           queryString += `&${filterKey}=${filters[filterKey].join(',')}`;
         }
       
         return `${window.location.pathname}?${queryString}`;
       };
       //console.log("WTFFFFFFFFFFFFFFFF");
        let newUrl = generateHref(activeFilters);
        //redirect(newUrl);
        console.log("____________, NEW URK",newUrl);

        // Pozici scrollu si ukládá jen proklik na detail (handleProductItem).
        // Při změně filtru/stránkování se NEukládá — po načtení výsledků se
        // scrolluje nahoru, jinak by uživatel u krátkého výsledku koukal na bílou stránku.

        navigate(newUrl,{replace: false});
      
      },[updateUrl]);
     
const prevPagination = () => {
  setActiveFilters(prevActiveFilters=>({
    ...prevActiveFilters,
    page: Math.max(prevActiveFilters.page - 1, 1)
  }))
  setUpdateUrl((prevupdateUrl) => ({...prevupdateUrl,
    state: !updateUrl.state,
    replaceUrl: true
  }));
   //setNumPage();
}

const nextPagination = () => {
  if(productsData.isLoaded){
  setActiveFilters(prevActiveFilters=>({
    ...prevActiveFilters,
    page: productsData.items.length > 0 ? Math.max(prevActiveFilters.page + 1) : prevActiveFilters.page
  }))
  setUpdateUrl((prevupdateUrl) => ({...prevupdateUrl,
    state: !updateUrl.state,
    replaceUrl: true
  }));
}
   // setNumPage(Math.max(numPage + 1));
   /*
   if(productsData.items.length > 0){
     setNumPage(Math.max(numPage + 1)) }else{
       setNumPage(numPage);
     };
     */
}


const handleProductItem = (slug: string) => {
  const scrollPositions = JSON.parse(sessionStorage.getItem('scrollPositions') || '{}');
  scrollPositions["main"] = window.scrollY;
  sessionStorage.setItem('scrollPositions', JSON.stringify(scrollPositions));
  navigate(`/product/${slug}`);
}




const handleSorting = async (index: any, href: any) => {
  console.log("handlesorting");
   setSortingActive(index);
    
    
     //setReloadProducts(prevReloadProducts=>!prevReloadProducts);
     console.log("setting active filters");

     setActiveFilters((prevActiveFilters) => ({
      ...prevActiveFilters,
      sort: href
    }));
    setUpdateUrl((prevupdateUrl) => ({...prevupdateUrl,
      state: !updateUrl.state,
      replaceUrl: true
    }));
     

     console.log(activeFilters.sort);

 }




  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
   // Destructuring
   const { name, value, title, checked } = event.target;
   console.log(name, value, title, checked);
   //const value = parseInt(event.target.value, 10);
  
   //add received filter into structure
   if(checked){
    
    setSelectedFiltersCheckbox((prevSelectedFilters) => [...prevSelectedFilters, parseInt(value,10)]);

     //KEY = NAME
     //VALUE = ID_FILTER
     //title - NAME NOT IMPORTANT
     //CHECKHED..
     //const filter: filter
  
     let _activeFilters = { ...activeFilters };
     _activeFilters.page=1;
      //_activeFilters.page=;
     if(name in _activeFilters.filters){
       _activeFilters.filters[name].push(parseInt(value,10));
     }else{
       _activeFilters.filters[name] = [parseInt(value,10)];
     }


     setActiveFilters(_activeFilters);
     //remove received filter from structure
     //setUpdateUrl((updateUrl)=>(!updateUrl));
 }else{

  setSelectedFiltersCheckbox((prevSelectedFilters) =>
  prevSelectedFilters.filter((id) => id !== parseInt(value,10))
);
   
  
     // Create a copy of the activeFilters object to avoid mutating the state directly
let _activeFilters = { ...activeFilters };
_activeFilters.page=1;
if (name in _activeFilters.filters) {
 // Check if the key (name) exists in filters
 const valueToRemove = parseInt(value, 10);



 // Remove the value from the array associated with the key (name)
 _activeFilters.filters[name] =
_activeFilters.filters[name].filter((item) => item !== valueToRemove);

//remove key
 if (_activeFilters.filters[name].length === 0) {
   delete _activeFilters.filters[name];
 }

 // Update the state with the modified _activeFilters object
 setActiveFilters((prevFilters)=>(_activeFilters));
 //setUpdateUrl((updateUrl)=>(!updateUrl));

}

 
 }
 console.log("setUpdate url fired");
 setUpdateUrl((prevupdateUrl) => ({...prevupdateUrl,
   state: !updateUrl.state,
   replaceUrl: true
 }));
};






  const isFetching = !filtersState.isLoaded || !productsData.isLoaded;

  return (
    <>
      <TopProgressBar isActive={isFetching} />

      {filtersState.isLoaded &&
        <Sidebar filtersState={filtersState} selectedFilters={selectedFiltersCheckbox} text={"text"} handleChange={handleChange}></Sidebar>
      }

      {filtersState.isLoaded && productsData.items.length > 0 ? (
        <LoadingOverlay isLoading={!productsData.isLoaded} text="Načítám produkty…">
          <ProductList
            paginationOn={productsData.isLoaded}
            pData={productsData.items}
            sortingActive={sortingActive}
            handleSorting={handleSorting}
            productID={productItem.productID}
            handleProductItem={handleProductItem}
            prevPagination={prevPagination}
            nextPagination={nextPagination}
            numPage={activeFilters.page}
            nextPageCount={productsData.nextPageCount}
          />
        </LoadingOverlay>
      ) : (
        <>{filtersState.isLoaded && productsData.isLoaded && productsData.items.length == 0 ? <ProductNotFound /> : <div><Spinner /></div>}</>
      )}
    </>
  );
  
};

export default Products;